//--------------- IMPORTAÇÕES ---------------//
import { useEffect, useContext } from "react";
import { SidebarContext } from "../../context/SidebarContext";
import { Main } from "./components";
import { loadProfileService } from "./services";



//--------------- EXPORTAÇÃO DO COMPONENTE SIDEBAR ---------------//
export default function Sidebar() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { user, setUser } = useContext(SidebarContext); // Estado que armazena o Objeto Usuário
    const { isOpen, setIsOpen } = useContext(SidebarContext); // Contexto que armazena se a Sidebar está aberta ou não
    const { showText, setShowText } = useContext(SidebarContext); // Estado que armazena se os Textos da Sidebar estão sendo exibidos ou não



    //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
    useEffect(() => {
        handleLoadProfile();
    }, []);



    //--------------- USE EFFECT DE ATUALIZAÇÃO ---------------//
    // Atualiza a Sidebar quando ela é aberta e fechada
    useEffect(() => {
        let timerText; // Variável local timer
        if (isOpen) {
            timerText = setTimeout(() => setShowText(true), 100);// Espera 300ms para mostrar o texto
        } else {
            setShowText(false);// Se fechar, esconde o texto imediatamente
        }
        return () => clearTimeout(timerText); // Evita bugs se desmontar rápido
    }, [isOpen]);



    //--------------- FUNÇÃO ASSÍNCRONA LOAD PROFILE ---------------//
    // Responsável por requisitar à API as informações do usuário que está logado
    // Armazena as informações no Objeto "user"
    async function handleLoadProfile() {
        const response = loadProfileService();
        if (response) {
            setUser(response.data);
        }
    };



    //--------------- RETORNO DO COMPONENTE SIDEBAR ---------------//
    return (
        <>
            {user !== null && <Main />}
        </>
    );
}